// extracted by mini-css-extract-plugin
module.exports = {"jk-link":"_7a3fb80146--jk-link--L809K","subtitle":"_7a3fb80146--subtitle--RwsPn"};